module.exports = __webpack_public_path__ + "media/images/logo-light-1b3e3525582e2466aa50deee688f7922.png";